import React from 'react';
import { Wordmark } from '@99designs/branding';
import { Box } from '@99designs/emu';
import SiteFooter from '@99designs/site-navigation/components/SiteFooter/SiteFooter';
import { useSite } from '@99designs/spa-common';

function PageLayout({
    children,
    maxWidth = '400px',
    showFooter = true,
}: {
    children: React.ReactNode;
    maxWidth?: string;
    showFooter?: boolean;
}) {
    const site = useSite();

    return (
        <Box as="main" display="flex" flexDirection="column" flexGrow={1}>
            <Box display="flex" justifyContent="center" padding={['1bu', '2bu']} flexGrow={1}>
                <Box flexGrow={1} maxWidth={maxWidth}>
                    <Box display="flex" justifyContent="center" paddingBottom="2bu">
                        <a href="/" title={__('99designs by Vista')}>
                            <Wordmark />
                        </a>
                    </Box>
                    {children}
                </Box>
            </Box>
            {showFooter && (
                <Box marginTop="2bu" width="100%">
                    <SiteFooter isFocused site={site} />
                </Box>
            )}
        </Box>
    );
}

export default PageLayout;
